import api from '@/utils/api';

/**
 * Get a Company Product
 * @param {string} companyId - Query to filter companies
 * @param {string} productId - The product id
 * @returns {Promise}
 */
const getCompanyProductApi = (companyId, productId) =>
  api.get(`company/${companyId}/product/${productId}`);

export default getCompanyProductApi;
